var map = {
	"./icon1-1.png": "9a34",
	"./icon1.png": "6b7d",
	"./icon2-1.png": "5c45",
	"./icon2.png": "6ce0",
	"./icon3-1.png": "a5ea",
	"./icon3.png": "88b8",
	"./icon4-1.png": "fcf5",
	"./icon4.png": "ea62",
	"./icon5-1.png": "42f2",
	"./icon5.png": "736d",
	"./icon6-1.png": "91ea",
	"./icon6.png": "cbdd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "858d";